var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29065 29.3369C4.29065 32.7135 6.76308 35.4513 9.81331 35.4513C12.8628 35.4513 15.3352 32.7135 15.3352 29.3369H4.29065Z",
    fill: "#C5F4E0",
    stroke: "#63768D",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4373 29.3369C27.4373 32.7135 29.9097 35.4513 32.9591 35.4513C36.0094 35.4513 38.4818 32.7135 38.4818 29.3369H27.4373Z",
    fill: "#C5F4E0",
    stroke: "#63768D",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14286 16.7146H2.33551C1.04641 16.7146 0 15.9298 0 14.9638V14.6091C0 13.6414 1.04641 12.8574 2.33551 12.8574H5.14286V16.7146Z",
    fill: "#C5F4E0",
    stroke: "#63768D",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5714 16.7146H40.6765C41.6439 16.7146 42.4286 15.9298 42.4286 14.9638V14.6091C42.4286 13.6414 41.6439 12.8574 40.6765 12.8574H38.5714V16.7146Z",
    fill: "#C5F4E0",
    stroke: "#63768D",
    strokeWidth: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2866 15.1335C39.4228 15.3239 39.503 15.5572 39.503 15.8092V28.1736C39.503 28.8155 38.9815 29.3369 38.3397 29.3369H4.48631C3.84371 29.3369 3.323 28.8155 3.323 28.1736V15.8092C3.323 15.4707 3.46746 15.166 3.69811 14.9535L7.92742 5.72637C9.35842 2.70083 12.4056 0.771484 15.752 0.771484H26.8035C30.0813 0.771484 33.0775 2.62214 34.544 5.55357L39.2866 15.1335Z",
    fill: "#81E5BD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2866 15.1335L38.8385 15.3553L38.8564 15.3915L38.8799 15.4243L39.2866 15.1335ZM3.69811 14.9535L4.03695 15.3212L4.11079 15.2531L4.15263 15.1618L3.69811 14.9535ZM7.92742 5.72637L7.4754 5.51257L7.47289 5.51803L7.92742 5.72637ZM34.544 5.55357L34.9921 5.33174L34.9912 5.32987L34.544 5.55357ZM38.8799 15.4243C38.9575 15.5328 39.003 15.665 39.003 15.8092H40.003C40.003 15.4494 39.8881 15.1151 39.6933 14.8427L38.8799 15.4243ZM39.003 15.8092V28.1736H40.003V15.8092H39.003ZM39.003 28.1736C39.003 28.5393 38.7054 28.8369 38.3397 28.8369V29.8369C39.2577 29.8369 40.003 29.0916 40.003 28.1736H39.003ZM38.3397 28.8369H4.48631V29.8369H38.3397V28.8369ZM4.48631 28.8369C4.12007 28.8369 3.823 28.5395 3.823 28.1736H2.823C2.823 29.0914 3.56735 29.8369 4.48631 29.8369V28.8369ZM3.823 28.1736V15.8092H2.823V28.1736H3.823ZM3.823 15.8092C3.823 15.6161 3.90475 15.443 4.03695 15.3212L3.35926 14.5858C3.03017 14.8891 2.823 15.3253 2.823 15.8092H3.823ZM4.15263 15.1618L8.38195 5.93471L7.47289 5.51803L3.24358 14.7452L4.15263 15.1618ZM8.37942 5.94015C9.72775 3.08938 12.5989 1.27148 15.752 1.27148V0.271484C12.2122 0.271484 8.98909 2.31227 7.47543 5.51259L8.37942 5.94015ZM15.752 1.27148H26.8035V0.271484H15.752V1.27148ZM26.8035 1.27148C29.892 1.27148 32.7151 3.01525 34.0969 5.77727L34.9912 5.32987C33.44 2.22904 30.2706 0.271484 26.8035 0.271484V1.27148ZM34.0959 5.7754L38.8385 15.3553L39.7347 14.9117L34.9921 5.33174L34.0959 5.7754Z",
    fill: "#63768D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.76133 15.0553C7.40485 15.0553 7.16373 14.7529 7.29854 14.4778L10.6478 7.64148C11.7902 5.61994 14.2223 3.48389 16.8941 3.48389H25.7148C28.3317 3.48389 30.7228 5.56819 31.8937 7.52633L35.5042 14.4691C35.6481 14.7459 35.4056 15.0553 35.0456 15.0553H7.76133Z",
    fill: "#C5F4E0",
    stroke: "#63768D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9091 25.7164H18.3998C17.8173 25.7164 17.3429 25.2435 17.3429 24.6595V24.0871C17.3429 23.5032 17.8173 23.0303 18.3998 23.0303H24.9091C25.493 23.0303 25.9659 23.5032 25.9659 24.0871V24.6595C25.9659 25.2435 25.493 25.7164 24.9091 25.7164Z",
    fill: "#63768D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6036 19.8208L32.0527 22.5586C31.5459 22.9304 30.813 22.8479 30.4142 22.3735L29.7577 21.5897C29.156 20.8715 29.7021 19.8208 30.6757 19.8208H35.6036Z",
    stroke: "#63768D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22192 19.8208L10.7728 22.5586C11.2804 22.9304 12.0133 22.8479 12.4113 22.3735L13.0686 21.5897C13.6703 20.8715 13.1241 19.8208 12.1506 19.8208H7.22192Z",
    stroke: "#63768D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6001 19.8208H7.78064",
    stroke: "#63768D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.d73b50cc.svg";
export { ForwardRef as ReactComponent };